module.exports = __webpack_public_path__ + "static/media/26a.69b878bf.jpg";